import { Injectable } from '@angular/core';
import {HttpWrapper} from '../../../shared';
import {DateRange} from '../../../shared/components/date-range.component';
import {from, Observable} from 'rxjs';
import {GeoCoordinateDMS} from '../../models/GeoCoordinate';
import { NoonReportServiceSpa } from 'src/app/generated/services/transportation/reports/noonSpa';
import { VesselReportV202205 } from 'src/app/generated/services/transportation/reports/noon';
export { VesselReportV202205, VesselReportedMainEngineBunkerConsumption, BunkerReportPart } from 'src/app/generated/services/transportation/reports/noon';
import { exportExcel } from '../noon-reports/noon-reports-v202205/noon-reports-v202205-excel-export';

export interface VesselInfo {
  vesselName?: string;
  vesselImo?: string;
  master?: string;
}

export interface VesselReportDate {
  isoDate: string; // '2022-05-24T12:08Z+04:00'
}

export interface VesselReportedPlan {
  fromOrganisationId?: string;
  toOrganisationId?: string;
  eta?: string;
}

export interface StoppedStatus {
  status?: string;
  locationOrganisationId?: string;
  atSeaOrAtBerth?: VesselReportedPositionStatus;
  since?: string;
}

export interface UnknownMovingStatus {
  status?: string;
  description?: string;
}

export interface VesselReportedDistances {
  distanceCovered?: number;
  distanceByMainEngine?: number;
  distanceToGo?: number;
  totalDistanceRun?: number;
}

export interface VesselReportedLocation {
  geoCoordinate?: GeoCoordinateDMS;
  currentLocation?: string;
  bearing?: number;
}

export interface VesselReportedSpeed {
  averageCurrentReportSpeed?: number;
  averageVoyageSpeed?: number;
}

export enum Direction {
  calm = 'calm',
  north = 'north',
  south = 'south',
  west = 'west',
  east = 'east',
  northWest = 'northWest',
  northEast = 'northEast',
  southWest = 'southWest',
  southEast = 'southEast',
}

export enum MainDirection {
  north = 'north',
  south = 'south',
  west = 'west',
  east = 'east',
}

export const DirectionPresentationMappings = new Map<string, string>([
  ['north', 'North'],
  ['south', 'South'],
  ['west', 'West'],
  ['east', 'East'],
  ['northWest', 'North West'],
  ['northEast', 'North East'],
  ['southWest', 'South West'],
  ['southEast', 'South East'],
]);

export interface WeatherForce {
  force?: number;
  direction?: Direction;
}

export interface VesselReportedWeatherCondition {
  seaForce?: WeatherForce;
  windForce?: WeatherForce;
  currentForce?: WeatherForce;
  swellForce?: WeatherForce;
}

export interface VesselReportedDraft {
  forwardDraft?: number;
  middleDraft?: number;
  aftDraft?: number;
}

export interface VesselReportedTankCondition {
  tankNo: string;
  product: string;
  quantity: number;
  temperature: number;
}

export interface VesselReportedLastReceived {
  receivedType?: string;
  timestamp?: number;
  quantityMT?: number;
}

export enum VesselReportedPositionStatus {
  atSea = 'atSea',
  atPort = 'atPort',
  atBunkering = 'atBunkering',
}

export enum ManoeuvringStatus {
  manoeuvring = 'manoeuvring',
  steaming = 'steaming',
  drifting = 'drifting',
}

export const ManoeuvringStatusMap = new Map<number, string>([
  [ 0, 'Unspecified'],
  [ 1, 'Manoeuvring'],
  [ 2, 'Steaming'],
  [ 3, 'Drifting'],
  [ -1, '']
]);

export const BunkerReportPartMap = new Map<number, string>([
  [ 0, 'Unspecified'],
  [ 1, 'Main Engine'],
  [ 2, 'Power Generator'],
  [ 3, 'Boilers'],
  [ 4, 'ROBs'],
  [ 5, 'Incinerator'],
  [ 6, 'IGG'],
  [ 7, ' '],
  [ -1, '']
]);

export const BunkerTypeMap = new Map<number, string>([
  [ 0, 'Unspecified'],
  [ 1, 'HFO'],
  [ 2, 'VLSFO'],
  [ 3, 'ULSFO'],
  [ 4, 'MGO'],
  [ 5, 'LSMGO'],
  [ -1, '']
]);

export interface VesselReportedLubOilStatus {
  mainEngineCylinderOilConsumption: number;
  mainEngineSystemOilConsumption: number;
  auxiliarySystemOilConsumption: number;
  mainEngineCylinderOilRob: number;
  mainEngineSystemOilRob: number;
  auxiliarySystemOilRob: number;
}

export interface VesselReportedFreshWaterStatus {
  rob?: number;
  consumption?: number;
  generated?: number;
}

export const mapDirection = (direction: string | undefined) => {
  if (direction) {
    return DirectionPresentationMappings.get(direction);
  }
  return null;
};

@Injectable({
  providedIn: 'root'
})
export class NoonReportsV202205Service {

  constructor(private _httpWrapper: HttpWrapper, private _noonReportService: NoonReportServiceSpa) { }

  getNoonReportsV202205Between(dr: DateRange): Observable<VesselReportV202205[]> {
    return from(this._noonReportService.getNoonReportsV202205Between({
      startTime: dr.startDate.getTime(),
      endTime: dr.endDate.getTime(),
    }).then(r => r.reports));
  }

  downloadReports(startTime: number, endTime: number) {
    return this._httpWrapper.download(`vessels/noon-reports-v202205/reports/${startTime}/${endTime}`);
  }

  generateFile(report: VesselReportV202205, organisationsNameMap : Map<string, string>) {
    exportExcel(report, organisationsNameMap);
  }
}
